import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import FlowParentalInformationForm from '../components/FlowParentalInformationForm.jsx';
import { ChatContext } from '../contexts/ChatContext';
import i18n from '../i18n';
import useRouting from '../hooks/useRouting';
import { patchStorage, retrieveStorageById } from '../helpers/storeService';
import FlowChatBox from '../components/FlowChatBox';

const FlowHealthInformation = () => {
  const [defaultValues, setDefaultValues] = useState({});
  const { renderNextRoute } = useRouting();
  const { addQuestion, addAnswer } = useContext(ChatContext);
  const { id, affinity, insuranceType, currentHealth } = useParams();

  useEffect(() => {
    const { data } = retrieveStorageById(id, affinity, insuranceType);
    const { healths } = data;
    if (healths[currentHealth] !== null) {
      setDefaultValues(healths[currentHealth]);
    }
    const question = {
      message: i18n.t('Do both your parents smoke?'),
      slug: 'parental-information',
    };
    addQuestion(question);
  }, []);

  const isMobile = () => {
    if (
      insuranceType === 'allMobile' ||
      insuranceType === 'carMobile' ||
      insuranceType === 'healthMobile' ||
      insuranceType === 'homeMobile'
    ) {
      return true;
    } else {
      return false;
    }
  };

  const fixData = (values) => {
    if (
      values?.ParentsSufferFromAtheroscleroticCirculatoryDiseaseOrPeripheralCardiovascularOrCerebrovascularDisorderOrDiabetesMellitus !==
      'yes'
    ) {
      values.YoungestParentAge = null;
    }
    return values;
  };

  function handleSubmit(values) {
    const {
      AreBothOYourParentsSmokers,
      NoOfCigarettesParentsSmoke,
      ParentsSufferFromAtheroscleroticCirculatoryDiseaseOrPeripheralCardiovascularOrCerebrovascularDisorderOrDiabetesMellitus,
      YoungestParentAge,
    } = values || {};

    const payload = fixData({
      AreBothOYourParentsSmokers,
      NoOfCigarettesParentsSmoke:
        AreBothOYourParentsSmokers === 'yes' ? NoOfCigarettesParentsSmoke : 0,
      ParentsSufferFromAtheroscleroticCirculatoryDiseaseOrPeripheralCardiovascularOrCerebrovascularDisorderOrDiabetesMellitus,
      YoungestParentAge,
    });
    let answer;
    if (AreBothOYourParentsSmokers === 'yes') {
      answer = {
        message: i18n.t(`Yes, both my parents smoke cigarettes a day`, {
          amount: NoOfCigarettesParentsSmoke,
        }),
        slug: 'doctor-information',
      };
    } else {
      answer = {
        message: i18n.t(`No, my parents do not smoke cigarettes`),
        slug: 'doctor-information',
      };
    }

    addAnswer(answer);

    patchStorage({
      payload,
      path: ['healths', [currentHealth]],
      id,
      affinity,
      insuranceType,
    });
    renderNextRoute(1, { health: currentHealth });
  }

  return (
    <SplitContainer>
      {!isMobile() && <FlowChatBox />}
      <RightSplit>
        <FlowParentalInformationForm
          handleFormValues={handleSubmit}
          defaultValues={
            defaultValues.health ? defaultValues.health : defaultValues
          }
        />
      </RightSplit>
    </SplitContainer>
  );
};

const SplitContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  @media (max-width: 768px) {
    display: flex;
  }
`;

const RightSplit = styled.div`
  padding-left: 4rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 1rem;
    width: 100%;
  }
`;

export default FlowHealthInformation;
